import { Grid, GridItem } from "@chakra-ui/react"
import { Form, UI } from "components"
import { useEffect, useState } from "react"

export default function Options({ options = [], value, colorPalette = 'orange', defaultValue = false, onChange = () => {}, ...props }){

    const  [ selected, setSelected ] = useState(value ?? defaultValue)

    useEffect(() => {
        onChange(selected)
    }, [selected])

    return(
    <Form.Field {...props}>
        <Grid templateColumns={{ base: '1fr', sm: '1fr', md: 'repeat(3, 1fr)', lg: 'repeat(4, 1fr)' }} gap={4}>
            { options.map(item => <GridItem key={item.value}><UI.Option selected={selected==item.value} onClick={() => setSelected(item.value)} disabled={props?.disabled} title={item.label} tagline={item.description} icon={item.icon} colorPalette={colorPalette ?? item?.colorPalette} /></GridItem>) }
        </Grid>
    </Form.Field>
    )
}